import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <div data-testid="not-found-page" className="pt-40 md:pt-56 pb-24 max-w-3xl mx-auto px-6 md:px-12 text-center">
      <p className="text-overline mb-4">404</p>
      <h1 className="font-display font-black uppercase tracking-tighter text-6xl md:text-8xl leading-[0.9]">
        Λάθος<br/><span className="text-[#E50000]">στροφή.</span>
      </h1>
      <p className="mt-6 text-white/60">Αυτή η διαδρομή δεν υπάρχει. Ας σε γυρίσουμε πίσω στο showroom.</p>
      <Link to="/" data-testid="not-found-home-btn" className="btn-primary text-xs mt-10 inline-flex">Πίσω στην Αρχική</Link>
    </div>
  );
}
